import React from 'react'
import { Button, Icon, Input } from '@node-space/ui-components'
import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import type { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'
import type { FormFieldLabels } from 'pages/Contacts/types/fiatInstruments'

type BankCodeFieldProps = {
  register: UseFormRegister<ContactFiatInstrumentFormData>
  errors: FieldErrors<ContactFiatInstrumentFormData>
  formFieldLabels: FormFieldLabels
  isLoading: boolean
  isValidBankCode: boolean
  bankCode?: string
  onBlur: () => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const BankCodeField = ({
  register,
  errors,
  formFieldLabels,
  isLoading,
  isValidBankCode,
  bankCode,
  onBlur,
  onChange,
}: BankCodeFieldProps) => {
  return (
    <Input
      {...register('bankCode')}
      name="bankCode"
      testId="bankCode"
      label={formFieldLabels.bankCode}
      placeholder={formFieldLabels?.bankCodePlaceholder}
      errorText={errors?.bankCode?.message}
      error={!!errors?.bankCode?.message}
      loading={isLoading}
      onChange={onChange}
      onBlur={onBlur}
      IconButton={
        isValidBankCode && bankCode ? (
          <Button variant="ghost" iconElement={<Icon name="Check" />} />
        ) : undefined
      }
      iconPosition="right"
    />
  )
}

